<template>
  <div class="teamLeader">
    <ul class="teamLeaderList">
      <li v-for="(item, index) in list" :key="index">
        <router-link :to="'/contentTeam?id=' + item.id" class="clearfloat" target="_blank">
          <div class="fl">
            <el-image
              style="width: 100%; height: 100%"
              :src="item.img"
              fit="cover"
            >
            </el-image>
          </div>
          <div class="inner">
            <div class="teamLeaderHd">
              {{ item.name }} <span>{{ item.position }}</span>
            </div>
            <div class="teamLeaderCont multi-line3">{{ setText(item.info) }}</div>
          </div>
        </router-link>
      </li>
    </ul>

    <div class="teamLeaderPage">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="12"
        @current-change="handleCurrent"
        >
      </el-pagination>
    </div>
    
  </div>
</template>

<script>
export default {
  props: {
    groupId: {
      typeof: [Number, String, Boolean],
      default: null
    }
  },
  data() {
    return {
      pageNum: 1,
      total: 0,
      list: [
        // {
        //   name: "张某某",
        //   img: require("@/assets/img/team/memories_b1.jpg"),
        //   position: "董事长、执行董事长",
        //   info: "张某某张某某张某某张某某，张某某张某某张某某张某某，张某某张某某张某某张某某张某某张某某，张某某张某某张某某张某某张某某某，张某某张某某张某某张某某张某某，张某某张某某张某某张某某张某某某，张某某张某某张某某张某某张某某，张某某张某某张某某张某某张某某某，张某某张某某张某某张某某张某某，张某某张某某张某某张某某张某某某，张某某张某某张某某张某某张某某，张某某张某某张某某张某某张某某，张某某张某某张某某张某某张某张某某张某某张某某张某某张某某，张某某张某某张某某"
        // },
      ]
    };
  },
  mounted() {
    var _this = this

    _this.getList()
  },
  methods: {
    handleCurrent(val) {
      var _this = this

      _this.pageNum = val
      _this.getList()
    },
    handleTeam(val) {
      const routeUrl = this.$router.resolve({
        path: "/contentTeam",
        query: { id: val }
      });
      window.open(routeUrl.href, "_blank");
    },
    async getList(){
      var _this = this
      var { data } = await _this.$http.post(_this.apiUrl + '/managementTeam/getManagementTeamInfoList',{classification: _this.groupId, page: _this.pageNum});
      if(data.code == 200){
        _this.list = data.data.list
        _this.total = data.data.total
      }
    },
    // 提取纯文本
    setText(val) {
      if (val != null && val != "") {
        var re1 = new RegExp("<.+?>|&.+?;","g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
        var msg = val.replace(re1,""); //执行替换成空字符
        msg = msg.replace(/\s/g,""); //去掉所有的空格（中文空格、英文空格都会被替换）
        msg = msg.replace(/[\r\n]/g,""); //去掉所有的换行符
        // return msg.substr(0, 100); //获取文本文字内容的前100个字符
        return msg;
      } else return ""
    },
  }
};
</script>

<style>
.teamLeaderList {
  margin-top: 10px;
}
.teamLeaderList li {
  /* margin-bottom: 15px; */
  border-bottom: 1px solid #e5e5e5;
  /* padding: 12px;
  cursor: pointer;
  -moz-transition: all 0.3s ease-in;
  -webkit-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in; */
}
.teamLeaderList li a {
  display: block;
  padding: 12px;
}
.teamLeaderList li a:hover {
  background-color: #f7f7f7;
}
.teamLeaderList li .fl {
  width: 108px;
  height: 142px;
}
.teamLeaderList li .inner {
  margin-left: 132px;
}
.teamLeaderHd {
  font-weight: bold;
  font-size: 16px;
  line-height: 30px;
}
.teamLeaderHd span {
  /* font-size: 4px; */
  margin-left: 4px;
}
.teamLeaderCont {
  font-size: 14px;
  line-height: 24px;
  text-indent: 2em;
  margin-top: 6px;
}
.teamLeaderPage {
  text-align: center;
  margin: 40px 0;
}
</style>
